$(function () {
  const e = $(".unselected-size-warning"),
    t = $(".unselected-size-warning__mobile"),
    a = $(".product__submit__add"),
    s = $(".disabled-overlay"),
    l = $("input[data-single-option-selector]"),
    n = $("[data-unselected-message]"),
    c = $(".product__vendor"),
    o = localStorage.getItem("gender"),
    i = c
      .text()
      .toLowerCase()
      .replace(/[ &./]/g, "-");
    if ('SER.O.YA' == c[0].text) {
        c.attr("href", "https://blueandcream.com/collections/w-seroya");
    } else {
        "women" == o || "" == o
        ? c.attr("href", `https://blueandcream.com/collections/w-${i}`)
        : c.attr("href", `https://blueandcream.com/collections/m-${i}`),
        a.addClass("available-btn"),
        l.click(function () {
          s.css("display", "none"), n.text("");
        });
    }
  var d = $(window).width();
  s.click(function () {
    n.text("Please select a size"),
      d > 767
        ? (e.text("Please select a size"),
          e.fadeIn("slow"),
          setTimeout(() => {
            e.fadeOut(1e3);
          }, 1e3))
        : (t.text("Please select a size"),
          t.fadeIn("slow"),
          setTimeout(() => {
            t.fadeOut(1e3);
          }, 1e3));
  }),
    dataOptionSelector.click(function () {
      e.text("");
    });
});
